import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import {
  faMicrochip,
  faLaptop,
  faMobileAlt,
  faSyringe,
  faBookReader,
  faIndustry
} from '@fortawesome/free-solid-svg-icons';

interface AppTypeSelectProps {
  value: number;
  onChange: (value: number) => void;
  cssClass?: string;
  allowAny?: boolean;
  fullWidth?: boolean;
}

const AppTypeSelect = ({ value, onChange, cssClass, allowAny, fullWidth }: AppTypeSelectProps) => {
  const { t } = useTranslation();

  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const value = event.target.value as number;

    // callback
    onChange(value);
  };

  return (
    <FormControl className={cssClass} size="small" fullWidth={fullWidth}>
      <InputLabel id="appTypeLabel">{t('f-com-apptype')}</InputLabel>
      <Select labelId="appTypeLabel" id="appTypeSelect" value={value} onChange={handleChange}>
        {allowAny && (
          <MenuItem value={0} id="app-any">
            {t('f-any')}
          </MenuItem>
        )}
        <MenuItem value={10}>
          <FontAwesomeIcon icon={faMicrochip} size="1x" />
          &nbsp;
          {t('f-com-apptype-sys')}
        </MenuItem>
        <MenuItem value={20}>
          <FontAwesomeIcon icon={faLaptop} size="1x" />
          &nbsp;
          {t('f-com-apptype-web')}
        </MenuItem>
        <MenuItem value={30}>
          <FontAwesomeIcon icon={faMobileAlt} size="1x" />
          &nbsp;
          {t('f-com-apptype-mob')}
        </MenuItem>
        <MenuItem value={40}>
          <FontAwesomeIcon icon={faSyringe} size="1x" />
          &nbsp;
          {t('f-injector')}
        </MenuItem>
        <MenuItem value={50}>
          <FontAwesomeIcon icon={faBookReader} size="1x" />
          &nbsp;
          {t('f-devices-readers-title')}
        </MenuItem>
        <MenuItem value={60}>
          <FontAwesomeIcon icon={faIndustry} size="1x" />
          &nbsp;
          {t('f-slaughterhouse-readers-title')}
        </MenuItem>
      </Select>
    </FormControl>
  );
};

export default AppTypeSelect;
